<template>
	<div class='container' v-if='visiable'>
		<div class="content">
			<div class="header">
				<p class="title">{{title}}</p>
				<div class="close">
					<div class="close-icon" @click='close'>
						<Icon type="ios-close" size="30"/>
					</div>
				</div>
			</div>
			<div class="coupons-box">
				<template v-for='coupon in coupons.couponList'>
					<div class="coupon" v-for='detail in coupon.detailList'  v-if='(!readonly && detail.useFlag == 0 && valid(detail,coupon.code) || isChecked(detail))'>
						<div class='validValue'>￥<span style="font-size: 35px;">{{detail.validValues}}</span></div>
						<div class="desc">
							<p class="name">{{getName(coupon.code)}}</p>
							<p class="valid-term">有效期：{{format(detail.validFrom)}} - {{format(detail.endValidTo)}}</p>
							<p class="valid-term" v-html="getDesc(coupon.code)"></p>
							<p class="code">优惠券编码：{{detail.couponCode}}</p>
						</div>
						<ccheckbox v-if='!readonly' @input='triggerCheck(detail)' :value='isChecked(detail)' :radius='30'/>
					</div>
				</template>
			</div>
			<div class="button" @click='confirm'>确认</div>
		</div>
	</div>
</template>

<script>
import {
	mapState,
	mapMutations,
	mapActions
} from 'vuex'
import util from '@/config/util'
import ccheckbox from '@/components/common/checkbox'
export default {
	data() {
		return {
			visiable:false,
			stashUsedCoupons:[],
		}
	},
	created() {
		this.$nextTick(function() {
			this.initData()
		})
	},
	props:{
		coupons:{
			type:Object,
			default:()=>{},
		},
		usedCoupons:{
			type:Array,
			default:()=>[]
		},
		title:{
			type:String,
			default:'可使用优惠券',
		},
		// 是否仅查看
		readonly:{
			type:Boolean,
			default:false
		},
	},
	mounted() {

	},
	watch:{

	},
	mixins:[],
	components: {
		ccheckbox,
	},
	computed: {
		...mapState({

		}),
	},
	methods: {
		...mapActions([
		]),
		async initData(){
		},
		isChecked(item){
			return this.usedCoupons.indexOf(item.couponCode) != -1;
		},
		triggerCheck(coupon) {
			this.$emit('triggerCoupon',{coupon,isChecked:!this.isChecked(coupon)});
		},
		close(){
			this.$emit('onCancelCoupons',this.stashUsedCoupons);
			this.visiable = false;
		},
		confirm(){
			this.visiable = false;
		},
		getName(code){
			let coupon = this.coupons.couponDefines.filter(item=>item.key == code);
			return coupon[0]? coupon[0].value.name : '';
		},
		show(){
			this.stashUsedCoupons = [...this.usedCoupons];
			this.visiable = true;
		},
		format(str){
			return (util.formatDate.format(Date.fromStr(str),'yyyy.MM.dd'));
		},
		getDesc(code){
			let coupon = this.coupons.couponDefines.filter(item=>item.key == code);
			return coupon[0]? coupon[0].value.description : '';
		},
		valid(coupon,defCode) {
			let def = this.coupons.couponDefines.filter(item=>item.key == defCode);
			let now = util.realNowTime();
			return Date.fromStr(coupon.validTo) >= now && Date.fromStr(coupon.validFrom) <= now
					&& def.length && Date.fromStr(def[0].value.validTo) >= now && Date.fromStr(def[0].value.validFrom) <= now;
		}
	},
}
</script>

<style lang='scss' scoped>
@import '@/style/mixin';
::-webkit-scrollbar {
	width: 0px;
	height: 0px;
	background-color: #F5F5F5;
}
.container {
	position:fixed;
	left:0;
	top: 0;
	right:0;
	bottom:0;
	background-color:rgba(0,0,0,0.3);
	z-index:9999;
	display:flex;
	align-items: center;
	justify-content: center;
}
.content {
	min-width: 525px;
	background-color:white;
	border-radius: 10px;
	padding:30px;
}
.header {
	border-left: 5px solid $blue;
	display:flex;
	justify-content: space-between;
	align-items: center;
	font-size: 0;
	.title {
		font-size: 16px;
		padding-left: 5px;
	}
	.close {
		cursor: pointer;
		.close-icon {
			color:$blue;
			@include wh(30px, 30px);
		}
	}
}
.coupons-box {
	padding-top: 10px;
	max-height: 60vh;
	overflow-y:scroll;
	word-break: break-all;
	.coupon {
		border:1px solid #eee;
		margin-right: 10px;
		margin-bottom: 10px;
		display:flex;
		align-items: center;
		padding:10px;
		.validValue {
			color:$blue;
			font-size: 16px;
			font-weight: bold;
			margin-right: 10px;
		}
		.desc {
			flex: 1;
			.name {
				font-weight: bold;
				font-size: 20px;
			}
			.code,.valid-term {
				line-height: 25px;
				font-size: 15px;
				color:#666;
			}
		}
	}
}
.button {
	background-color:$blue;
	color:white;
	text-align: center;
	font-size: 14px;
	border-radius: 5px;
	width: 70%;
	height:30px;
	line-height: 30px;
	margin: auto;
}
</style>